'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var BALANCE_QUERY = 'balance:query';
var BALANCE_UPDATED = 'balance:updated';
var BALANCE_CHANGED = 'balance:changed';
var BALANCE_CURRENCY_QUERY = 'balance-currency:query';
var BALANCE_CURRENCY_CHANGE = 'balance-currency-set:command';
var BALANCE_CURRENCY_UPDATED = 'balance-currency:updated';
var BALANCE_FIAT_CURRENCY_QUERY = 'balance-fiat-currency:query';
var UPDATE_DEPOSIT_RESTRICTION = 'update-deposit-restriction';
var US_DOLLARS_BALANCE_UPDATED = 'us-dollars-balance-updated';
var LOCKED_AMOUNT_UPDATED = 'locked-balance:updated';

exports.BALANCE_CHANGED = BALANCE_CHANGED;
exports.BALANCE_CURRENCY_CHANGE = BALANCE_CURRENCY_CHANGE;
exports.BALANCE_CURRENCY_QUERY = BALANCE_CURRENCY_QUERY;
exports.BALANCE_CURRENCY_UPDATED = BALANCE_CURRENCY_UPDATED;
exports.BALANCE_FIAT_CURRENCY_QUERY = BALANCE_FIAT_CURRENCY_QUERY;
exports.BALANCE_QUERY = BALANCE_QUERY;
exports.BALANCE_UPDATED = BALANCE_UPDATED;
exports.LOCKED_AMOUNT_UPDATED = LOCKED_AMOUNT_UPDATED;
exports.UPDATE_DEPOSIT_RESTRICTION = UPDATE_DEPOSIT_RESTRICTION;
exports.US_DOLLARS_BALANCE_UPDATED = US_DOLLARS_BALANCE_UPDATED;
